import { useLocation } from "react-router";
import { HEADER_AD, MIDDLE_AD, FOOTER_AD, SLIDER_AD } from "#env/env-vars";
import { DangerousContent } from "#components/dangerous-content";
import { useEffect } from "react";

export function HeaderAd() {
  const location = useLocation();
  const key = `${location.pathname}${location.search}`;

  return !HEADER_AD ? undefined : (
    <DangerousContent
      key={key}
      className="ad-container"
      html={atob(HEADER_AD)}
    />
  );
}

export function MiddleAd() {
  const location = useLocation();
  const key = `${location.pathname}${location.search}`;

  return !MIDDLE_AD ? undefined : (
    <DangerousContent
      key={key}
      className="ad-container"
      html={atob(MIDDLE_AD)}
      allowRerender
    />
  );
}

export function FooterAd() {
  const location = useLocation();
  const key = `${location.pathname}${location.search}`;

  return !FOOTER_AD ? undefined : (
    <DangerousContent
      key={key}
      className="ad-container"
      html={atob(FOOTER_AD)}
      allowRerender
    />
  );
}

export function SliderAd() {
  const location = useLocation();
  const key = `${location.pathname}${location.search}`;

  useEffect(() => {
    // Remove old ads whenever location changes
    document.querySelectorAll('.ts-im-container').forEach(el => el.remove());
  }, [key]);

  useEffect(() => {
    // Cleanup on unmount
    return () => {
      document.querySelectorAll('.ts-im-container').forEach(el => el.remove());
    };
  }, []);

  document.querySelectorAll('.ts-im-container').forEach(el => el.remove());
  return SLIDER_AD ? (
    <DangerousContent
      key={key}
      className="ad-container-slider"
      html={atob(SLIDER_AD)}
      allowRerender
    />
  ) : null;
}
